import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";

import {
  DialogTitle,
  Grid,
  TextareaAutosize,
  TextField,
  Typography,
} from "@material-ui/core";
import Slide from "@material-ui/core/Slide";
import "./modal.css";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { Height } from "@material-ui/icons";

// import DialogTitle from '@material-ui/core/DialogTitle';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ebebeb",
    color: theme.palette.common.black,
    border: "1px solid #bfbfbf",
    padding: "10px",
  },
  body: {
    fontSize: 14,
    border: "1px solid #bfbfbf",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    background: "#fff",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#F8FCFF",
    },
  },
}))(TableRow);
export default function ExcelExportModal({
  openExelModal,
  handleExcelOpen,
  handleExcelClose,
  excelexportStataus,
  ExcelExportSubmitdata,
}) {
  console.log(excelexportStataus, "excelexportStatausffff");

  return (
    <div>
      <Dialog
        //className='Dialogbox'

        open={openExelModal}
        onClose={handleExcelClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        
      >
        <DialogTitle>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid>
              <h5>Import Vehicle By Excel</h5>
            </Grid>
            <Grid>
              <IconButton aria-label="close" onClick={handleExcelClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent
          style={{ width: "500px", maxHeight:"40vh",overflowY:"scroll" }}
        >
          <DialogContentText> </DialogContentText>
          
            <TableContainer>
                {/* {excelexportStataus.length>0 && (<> */}
              <h5 style={{ margin: "100 0px" }}>Error For Vehicles</h5>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>S.No</StyledTableCell>
                    <StyledTableCell>Vehicle Number</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {excelexportStataus.errorForVehicles &&
                    excelexportStataus.errorForVehicles.length>0 &&
                    excelexportStataus.errorForVehicles.map(
                      (vehicle, index) => (
                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {index + 1}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {vehicle}
                          </StyledTableCell>
                        </StyledTableRow>
                      )
                    )}
                </TableBody>
              </Table>
              {/* </> )} */}
            </TableContainer>
          
         
           
         
            <TableContainer>
                 {/* {excelexportStataus.length > 0 && (<>  */}
              <h5 style={{ margin: "10px 0px" }}>Vehicles Already Exist</h5>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>S.No</StyledTableCell>
                    <StyledTableCell>Vehicle Number</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {excelexportStataus.vehiclesAlreadyExist &&
                    excelexportStataus.vehiclesAlreadyExist.length > 0 &&
                    excelexportStataus.vehiclesAlreadyExist.map(
                      (vehicle, index) => (
                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {index + 1}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {vehicle}
                          </StyledTableCell>
                        </StyledTableRow>
                      )
                    )}
                </TableBody>
              </Table>
              {/* </> )}  */}
            </TableContainer>

            <TableContainer>
                 {/* {excelexportStataus.length>0 &&(<> */}
              <h5 style={{ margin: "10px 0px" }}>Vehicles Request Success</h5>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>S.No</StyledTableCell>
                    <StyledTableCell>Vehicle Number</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {excelexportStataus.vehiclesRequestSuccess &&
                    excelexportStataus.vehiclesRequestSuccess.length>0 &&
                    excelexportStataus.vehiclesRequestSuccess.map(
                      (vehicle, index) => (
                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {index + 1}
                          </StyledTableCell>
                          <StyledTableCell component="th" scope="row">
                            {vehicle}
                          </StyledTableCell>
                        </StyledTableRow>
                      )
                    )}
                </TableBody>
              </Table>
              {/* </> )}  */}
            </TableContainer>
          
          
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={handleExcelClose}
          >
            Cancel
          </Button>
          {/* <Button
                  style={{ marginLeft: "1rem" }}
                  variant="contained"
                  onClick={ExcelExportSubmitdata}
                >
                  Submit
                </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
